"use strict";

exports.HttpRepository = void 0;
var _crossFetch = require("cross-fetch");
class HttpRepository {
  constructor(baseUri) {
    this.baseUri = baseUri;
  }

  // eslint-disable-next-line class-methods-use-this
  async fetchAsync(uri, options) {
    const res = await _crossFetch(uri, options);
    let parsed = await res.json();
    parsed = {
      ...parsed,
      status: res.status
    };
    return parsed;
  }
  async getAsync(segment, options) {
    const uri = "".concat(this.baseUri, "/").concat(segment);
    return this.fetchAsync(uri, options);
  }
  async postAsync(segment, body, options) {
    const uri = "".concat(this.baseUri, "/").concat(segment);
    const defaultHeaders = {
      'Content-Type': 'application/json'
    };
    return this.fetchAsync(uri, {
      method: 'POST',
      body: JSON.stringify(body),
      headers: {
        ...defaultHeaders,
        ...(options === null || options === void 0 ? void 0 : options.headers)
      }
    });
  }
  async putAsync(segment, body, options) {
    const uri = "".concat(this.baseUri, "/").concat(segment);
    const defaultHeaders = {
      'Content-Type': 'application/json'
    };
    return this.fetchAsync(uri, {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: {
        ...defaultHeaders,
        ...(options === null || options === void 0 ? void 0 : options.headers)
      }
    });
  }
}
exports.HttpRepository = HttpRepository;